module.exports = __webpack_public_path__ + "img/104.5.bcc321b5.png";